import React from 'react'
import ServiceLayout from '../components/ServiceLayout'
import { useTranslation, Trans } from 'react-i18next'

const NewsPage = () => {
    const { t } = useTranslation()

    return (
        <ServiceLayout
            breadcrumbs={[
                { label: t('header.home'), path: '/' },
                { label: t('header.news', 'News') }
            ]}
            title={t('header.news', 'News')}
            subtitle={t('newsPage.subtitle', 'Latest updates and announcements.')}
        >
            <div className="bio-card-static rounded-xl p-8 border border-primary-200 text-center">
                <span className="material-symbols-outlined text-primary text-4xl mb-4 block">article</span>
                <h2 className="text-xl font-bold text-primary mb-2">{t('newsPage.comingSoon.title', 'News & Updates Coming Soon')}</h2>
                <p className="text-text-muted text-sm max-w-lg mx-auto leading-relaxed">
                    <Trans i18nKey="newsPage.comingSoon.desc">
                        We are currently preparing our press releases and announcements. Subscribe to our updates or <a href="/contact" className="font-semibold text-primary hover:text-primary-dark transition-colors">contact us</a> for immediate inquiries.
                    </Trans>
                </p>
            </div>
        </ServiceLayout>
    )
}

export default NewsPage
